import React from "react";
import { AlertTriangle, RotateCcw } from "lucide-react";
import { reportError } from "../lib/monitor";

// Catches a render crash in one panel and shows a recoverable card instead of a white screen.
export class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null, tries: 0 }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { reportError(error, `boundary:${this.props.name || "panel"}`, info?.componentStack); }
  reset = () => this.setState((s) => ({ error: null, tries: s.tries + 1 }));
  render() {
    if (!this.state.error) return <React.Fragment key={this.state.tries}>{this.props.children}</React.Fragment>;
    const full = this.props.full;
    // Chrome / Edge page translation rewrites the DOM under React ("removeChild / insertBefore … not a child of this node")
    const translated = /removeChild|insertBefore|not a child of this node/.test(String(this.state.error?.message || "")) || document.documentElement.classList.contains("translated-ltr") || document.documentElement.classList.contains("translated-rtl");
    return (
      <div className={`flex ${full ? "h-[100dvh] w-screen" : "h-full w-full min-h-[120px]"} items-center justify-center bg-[#0c1017] p-6 text-[#e8e9ec]`} data-testid={`error-boundary-${this.props.name || "panel"}`}>
        <div className="max-w-md rounded-lg border border-[#3a2a2a] bg-[#1a1416] p-5 text-center">
          <AlertTriangle className="mx-auto mb-2 h-6 w-6 text-[#f5a524]" />
          <div className="text-[14px]">{full ? "Xpattern hit a problem" : `This ${this.props.name || "panel"} hit a problem`}</div>
          <div className="mt-1 text-[12px] text-[#9aa0a8]">It has been reported. Your work on the canvas is kept.</div>
          {translated && <div className="mt-2 rounded-md border border-[#f5a524]/40 bg-[#f5a524]/10 px-3 py-2 text-[12px] text-[#f5d08a]" data-testid="error-boundary-translate-hint">Your browser is translating this page, which breaks it. Click the Translate icon in the address bar → <b>Show original</b> (or "Never translate this site"), then press the button below.</div>}
          <div className="mt-3 flex justify-center gap-2">
            <button data-testid="error-boundary-retry" className="btn" onClick={this.reset}><RotateCcw className="h-3.5 w-3.5" /> {full ? "Try again" : "Reload panel"}</button>
            {full && <button data-testid="error-boundary-reload" className="btn-red" onClick={() => window.location.reload()}>Reload app</button>}
          </div>
        </div>
      </div>
    );
  }
}
